var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSplit = function SvgSplit(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    d: "M2.635 2 10 9l7.365-7q.651.684.627 1.634a2.2 2.2 0 0 1-.707 1.604l-5.618 5.333 1.127 1.08a3.4 3.4 0 0 1 1.777-.508q1.413 0 2.422 1.007A3.3 3.3 0 0 1 18 14.571q0 1.413-1.007 2.422-1.01 1.006-2.422 1.007t-2.42-1.007q-1.008-1.01-1.008-2.422 0-.571.206-1.142L10 12.142l-1.349 1.287q.206.571.206 1.142 0 1.413-1.007 2.422Q6.84 17.999 5.429 18q-1.413 0-2.422-1.007Q2.001 15.983 2 14.57t1.007-2.42q1.01-1.008 2.422-1.008.935 0 1.778.508l1.126-1.08-5.62-5.333a2.2 2.2 0 0 1-.706-1.604A2.2 2.2 0 0 1 2.635 2M5.43 15.714q.475 0 .81-.333.332-.334.332-.81 0-.475-.333-.81a1.1 1.1 0 0 0-.81-.332q-.475 0-.81.333a1.1 1.1 0 0 0-.332.81q0 .475.333.81.334.332.81.332m10.285-1.143q0-.475-.333-.81a1.1 1.1 0 0 0-.81-.332q-.475 0-.81.333a1.1 1.1 0 0 0-.332.81q0 .475.333.81.334.332.81.332.475 0 .81-.333.332-.334.332-.81"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSplit);
export default ForwardRef;